import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import React from 'react';
import { useNavigate } from 'react-router';
import InfoIcon from '@material-ui/icons/Info';
import { useApi } from '@backstage/core-plugin-api';
import ConfirmationNumberOutlinedIcon from '@material-ui/icons/ConfirmationNumberOutlined';
import { useStyles } from '../styles';
import Visibility from '@material-ui/icons/Visibility';
import InsertCommentIcon from '@material-ui/icons/InsertComment';
import EditIcon from '@material-ui/icons/Edit';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import WebOutlinedIcon from '@material-ui/icons/WebOutlined';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import PublicOutlinedIcon from '@material-ui/icons/PublicOutlined';
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import { DateTime } from 'luxon';
import { RunIcon } from './icons/RunIcon';
import { FileOpenIcon } from './icons/FileOpenIcon';
import { permitBuildApiRef } from '../../../../apis/permitToBuildApi';

const TicketCard = ({
  ticket,
  handleTicketClick,
  handleMappedAssetsClicked,
  handleCommentClicked,
  handleEditTicket,
  handleRunTicket,
}: any) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [downloadLinks, setDownloadLinks] = React.useState({
    jsonData: '',
    previewUrl: '',
    downloadUrl: '',
  });
  const p2bAPi = useApi(permitBuildApiRef);
  const getDownloadLinks = async () => {
    const filePaths = JSON.parse(ticket?.latest_run?.file_paths || '[]');
    let jsonFilePath = filePaths.find((a: any) => (a.type = 'json'))?.value;
    let filePath = filePaths.find((a: any) => a.type === 'docx')?.value;
    if (jsonFilePath && !jsonFilePath.startsWith('/')) {
      jsonFilePath = `/${jsonFilePath}`;
    }
    if (filePath && !filePath.startsWith('/')) {
      filePath = `/${filePath}`;
    }
    try {
      const response = await p2bAPi.getDownloadableFiles(
        jsonFilePath,
        filePath,
      );
      console.log('Download Links:', response);
      if (response) {
        setDownloadLinks(response);
      }
    } catch {}
  };
  React.useEffect(() => {
    if (ticket && ticket?.latest_run && !downloadLinks.jsonData) {
      getDownloadLinks();
    }
  }, [ticket]);

  return (
    <Card>
      <CardHeader
        title={<ConfirmationNumberOutlinedIcon />}
        classes={{ action: classes.ticketCardAction }}
        action={
          <span>{`Created on: ${
            ticket.ticket?.created_at
              ? DateTime.fromISO(ticket.ticket?.created_at).toFormat(
                  'dd MMM yyyy, hh:mm a',
                )
              : '-'
          }`}</span>
        }
      />
      <CardContent classes={{ root: classes.ticketCardContentPadding }}>
        <div className={`${classes.flexCenter} ${classes.gap1}`}>
          <span className={`${classes.fontBold} ${classes.fontSize15}`}>
            {`Ticket number: ${ticket.ticket.snow_ticket_number}`}
          </span>
          {ticket?.latest_run &&
            (ticket?.latest_run?.status.toLowerCase() === 'failed' ||
              ticket?.latest_run?.status.toLowerCase() === 'error') && (
              <span
                style={{
                  color: 'red',
                }}
              >
                <Tooltip title="Last run failed to run">
                  <InfoIcon />
                </Tooltip>
              </span>
            )}
          {ticket?.latest_run &&
            (ticket?.latest_run?.status.toLowerCase() === 'in progress' ||
              ticket?.latest_run?.status.toLowerCase() === 'running') && (
              <span
                style={{
                  color: 'yellow',
                }}
              >
                <Tooltip title="The run is in progress">
                  <InfoIcon />
                </Tooltip>
              </span>
            )}
          <IconButton
            onClick={() => handleEditTicket(ticket.ticket)}
            classes={{ root: classes.editButton }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </div>
        <div
          className={`${classes.flexCenter} ${classes.gap1} ${classes.marginTop1}`}
        >
          <PersonOutlineOutlinedIcon
            fontSize="small"
            className={classes.tertiaryText}
          />
          <div className={`${classes.flexCenter} ${classes.gap1}`}>
            <span className={classes.tertiaryText}>Owner:</span>
            <span>{ticket.ticket.assigned_to}</span>
          </div>
        </div>
        <div
          className={`${classes.flexCenter} ${classes.gap1} ${classes.marginTop1}`}
        >
          <WebOutlinedIcon fontSize="small" className={classes.tertiaryText} />
          <div className={`${classes.flexCenter} ${classes.gap1}`}>
            <span className={classes.tertiaryText}>Application:</span>
            <span>{ticket.ticket.application_name}</span>
          </div>
        </div>
        <div
          className={`${classes.flexCenter} ${classes.gap1} ${classes.marginTop1}`}
        >
          <BusinessOutlinedIcon
            fontSize="small"
            className={classes.tertiaryText}
          />
          <div className={`${classes.flexCenter} ${classes.gap1}`}>
            <span className={classes.tertiaryText}>Line of Business:</span>
            <span>{ticket.ticket.tower}</span>
          </div>
        </div>
        <div
          className={`${classes.flexCenter} ${classes.gap1} ${classes.marginTop1}`}
        >
          <PublicOutlinedIcon
            fontSize="small"
            className={classes.tertiaryText}
          />
          <div className={`${classes.flexCenter} ${classes.gap1}`}>
            <span className={classes.tertiaryText}>Region:</span>
            <span>{ticket.ticket.region}</span>
          </div>
        </div>
        <Divider className={classes.marginTop1} />
        <div
          className={`${classes.flexCenter} ${classes.gap1} ${classes.marginTop1}`}
        >
          <PersonOutlineOutlinedIcon
            fontSize="small"
            className={classes.tertiaryText}
          />
          <div className={`${classes.flexCenter} ${classes.gap1}`}>
            <span className={classes.tertiaryText}>Modified By:</span>
            <span>{ticket.ticket.last_modified_by || ticket.ticket.assigned_to}</span>
            {/* <span>{ticket.ticket.last_modified_by}</span> */}
          </div>
        </div>
        <div
          className={`${classes.flexCenter} ${classes.gap1} ${classes.marginTop1}`}
        >
          <CalendarTodayOutlinedIcon
            fontSize="small"
            className={classes.tertiaryText}
          />
          <div className={`${classes.flexCenter} ${classes.gap1}`}>
            <span className={classes.tertiaryText}>Modifed Date:</span>
            <span>
              {ticket.ticket?.modified_at
                ? DateTime.fromISO(ticket.ticket?.modified_at).toFormat(
                    'dd MMM yyyy, hh:mm a',
                  )
                : '-'}
            </span>
          </div>
        </div>
      </CardContent>
      <CardActions classes={{ root: `${classes.padding1}` }}>
        <Button
          classes={{ root: classes.actionButtonWidth, label: classes.gap1 }}
          onClick={() => {
            handleRunTicket(ticket);
          }}
          disabled={
            ticket?.latest_run?.status.toLowerCase() === 'in progress' ||
            ticket?.latest_run?.status.toLowerCase() === 'running'
          }
        >
          <RunIcon />
          <span>Run</span>
        </Button>
        <Button
          classes={{ root: classes.actionButtonWidth, label: classes.gap1 }}
          onClick={() => {
            console.log(downloadLinks);
            handleMappedAssetsClicked({
              previewLink: downloadLinks.previewUrl,
              downloadLink: downloadLinks.downloadUrl,
            });
          }}
          disabled={
            !ticket?.latest_run ||
            !ticket?.latest_run?.run_id ||
            !downloadLinks.previewUrl ||
            ticket?.latest_run?.status.toLowerCase() === 'in progress' ||
            ticket?.latest_run?.status.toLowerCase() === 'running'
          }
        >
          <Visibility />
          <span>View</span>
        </Button>
        <Button
          classes={{ root: classes.actionButtonWidth, label: classes.gap1 }}
          disabled={
            !ticket?.latest_run ||
            !ticket?.latest_run?.run_id ||
            !downloadLinks.previewUrl ||
            ticket?.latest_run?.status.toLowerCase() === 'in progress' ||
            ticket?.latest_run?.status.toLowerCase() === 'running' ||
            !downloadLinks.jsonData
          }
          onClick={() => {
            navigate(`/manage-permit-build/${ticket.ticket.id}`, {
              state: {
                ticketId: ticket.ticket.id,
                ticketNumber: ticket.ticket.snow_ticket_number,
                description: ticket.ticket.description,
                jsonUrl: downloadLinks.jsonData,
              },
            });
          }}
        >
          <FileOpenIcon />
          <span>Open</span>
        </Button>
      </CardActions>
    </Card>
  );
};

export default TicketCard;
